import { Injectable } from '@angular/core';
import {environment} from '../../environments/environment-wrapper';

@Injectable()
export class SocialService {
  baseUrl = environment.baseServerUrl + 'api/v1/user';

  constructor() {}

  getProviderSetting(provider) {
    switch (provider) {
      case 'google': return 'https://www.googleapis.com/auth/userinfo.profile https://www.googleapis.com/auth/userinfo.email';
      case 'facebook': return 'public_profile,email';
      default: return 'Provider setting not defined';
    }
  }

  getProviderURL(provider) {
    return this.baseUrl + '/signin/' + provider;
  }
}
